import { createLogger } from "$/utils/logger";

export const projectLogger = createLogger("Project");
